export function debounce (func, delay) {
  let timeout

  function debounced (...args) {
    // Если прокидываем delay вторым аргументом (args[1]) после колбек фукнции
    // в компоненте, который использует миксин debounce, используем его
    if (args[1] !== undefined) {
      delay = args[1]
    }
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), delay)
  }
  debounced.cancel = function () {
    clearTimeout(timeout)
  }
  return debounced
}
